
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/eta-estimator/create",
      function () {
        return require("private-next-pages/eta-estimator/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/eta-estimator/create"])
      });
    }
  